import React from "react";
import LegalLayout from "./LegalLayout";

export default function DeleteAccount() {
  return (
    <LegalLayout kicker="ACCOUNT" title="Delete Your Qontri Account">
      <p>
        You may request deletion of your Qontri account and associated personal
        data.
      </p>

      <h2>Option 1: In-App Deletion</h2>
      <p>Open the Qontri app and navigate to:</p>
      <p>
        <strong>Profile → Settings → Delete Account</strong>
      </p>
      <p>Follow the confirmation steps.</p>

      <h2>Option 2: Email Request</h2>
      <p>Send an email from your registered email address to:</p>
      <p>
        <a href="mailto:support@qontri.in">support@qontri.in</a>
      </p>
      <p>
        <strong>Subject:</strong> Delete My Qontri Account
      </p>

      <h2>Processing Time</h2>
      <p>We will process account deletion requests within 30 days.</p>
      <p>
        Certain records may be retained when required by law, fraud prevention
        requirements, or security purposes.
      </p>
    </LegalLayout>
  );
}
